<template>
  <div>
    <div :id="type" :class="type"></div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "",
  },
});

const showAd = ref(true);
const debounce = ref(null);
const debounceAux = ref(null);

onMounted(() => {
  let n = "wegow";
  let region = window.location.href.split("/")[3];
  if (region !== "es") {
    n = "wegowipnoes";
  }
  let r = "es";
  let e = "smartIntxt";
  let c = "";
  let p = "96061";
  let t =
    "https://des.smartclip.net/ads?sc_sitName=" +
    n +
    "&sc_cc=" +
    r +
    "&elementId=" +
    e +
    "&cat=" +
    c;
  t +=
    "&ref=" +
    encodeURIComponent(window.top.document.URL) +
    "&rnd=" +
    Math.round(Math.random() * 1e8) +
    "&plc=" +
    p;
  let s = document.createElement("script");
  s.type = "text/javascript";
  s.src = t;
  s.defer = true;
  document.body.appendChild(s);

  // let p='68005'; let e=this.type;
  // let t='//des.smartclip.net/ads?type=dyn&sz=400x320';t+='&plc='+p;t+='&elementId='+e;
  // t+='&ref='+encodeURIComponent(window.top.document.URL);t+='&rnd='+Math.round(Math.random()*1e8);
  // let s=document.createElement('script');s.type='text/javascript';s.src=t;document.body.appendChild(s);
});
</script>
